// extracted by mini-css-extract-plugin
module.exports = {"bannerTwo":"_3pr1B","cloud1":"_16XGH","cloud2":"hNWqB","cloud3":"Tcncd","cloud4":"_3BEG7","person1":"_24SyQ","title":"_1xPOt","button":"MGYxg"};